<template>
  <div class="container-fluid">
    <h3 class="mt-3 mb-3">একক প্রোডাক্ট ভিত্তিক বিবরণী</h3>
    <div class="row mb-3">
      <form onsubmit="return false" class="form-inline">
        <label>প্রোডাক্ট নির্বাচন করুন</label>
        <b-form-select v-model="currentProduct" placeholder="ddsfdsfdsfds"
                       :options="productList"></b-form-select>
        <label>রিপোর্ট শুরুর তারিখ</label>
        <datepicker :highlighted="{ days: [5] }" input-class="form-control ml-2 mr-2" v-model="from"
                    format="dd MMMM yyyy"></datepicker>
        হতে
        <datepicker :highlighted="{ days: [5] }" input-class="form-control ml-2 mr-2" v-model="to"
                    format="dd MMMM yyyy"></datepicker>

        <label>পর্যন্ত</label>
        <button class="btn btn-primary ml-4" @click="getReportTraining">রিপোর্ট তৈরী করুন</button>
      </form>
    </div>
    <!--  class="text-center" -->
    <h3 class="mt-3">ক্রয় বিবরণী</h3>
    <table class="table table-striped align-middle">
      <thead>
      <tr>
        <th>তারিখ</th>
        <th>প্রোডাক্টের নাম</th>
        <th>ধরণ</th>
        <th class="text-right">পরিমান</th>
        <th class="text-right">ক্রয়মূল্য (দর)</th>
        <th class="text-right">Accurate ক্রয়মূল্য (দর)</th>
        <th class="text-right">বিক্রয়মূল্য (দর)</th>
        <th class="text-right">স্টক তথ্য</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="i in resultArray" v-bind:key="i.id" :class="i.status == 'in'? 'table-primary':i.purchaseRate==i.accuratePurchaseRate? 'table-success':'table-danger'">
        <td class="bn-number">{{ AmountService.toBanglaTextDate(i.date) }}</td>
        <td>{{ i.info.primaryName }}</td>
        <template v-if="i.status=='in'">
        <td>Purchase</td>
        </template>
        <template v-else>
          <td>Sales</td>
        </template>
        <td class="text-right bn-number">{{ i.quantity }}</td>
        <td class="text-right bn-number">
          <div v-if="i.purchaseRate==null" class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
          </div>
          <div v-else>{{ AmountService.commaDecimalWithCurrency(i.purchaseRate) }}</div>
          <template v-if="(i.purchaseRate!=i.accuratePurchaseRate)&&(i.status == 'out')">
            <button v-if="i.purchaseRate!=null" class="btn btn-danger d-block ml-auto" @click="fixPurchaseRate(i.id, i.accuratePurchaseRate)">সমাধান করুন</button>
            
          </template>
        </td>
        <td class="text-right bn-number">{{ AmountService.commaDecimalWithCurrency(i.accuratePurchaseRate) }}</td>
        <td class="text-right bn-number">{{ AmountService.commaDecimalWithCurrency(i.saleRate) }}</td>
        <td class="d-flex gap-3">
        <table class="table table-sm border border-black">
        <thead>
          <tr>
            <th colspan="2" class="text-center">পূর্বের</th>
        </tr>
          <tr>
          <th>পরিমান</th>
          <th>ক্রয়মূল্য</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="j in i.stockBefore" v-bind:key="j.id">
          <td class="text-center">{{j.quantity}}</td>
          <td class="text-center">{{j.purchaseRate}}</td>
        </tr>
        </tbody>
      </table>

      <table class="table table-sm border border-black">
        <thead>
          <tr>
            <th colspan="2" class="text-center">পরের</th>
          </tr>
          <tr>
          <th>পরিমান</th>
          <th>ক্রয়মূল্য</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="j in i.stockAfter" v-bind:key="j.id">
          <td class="text-center">{{j.quantity}}</td>
          <td class="text-center">{{j.purchaseRate}}</td>
        </tr>
        </tbody>
      </table>
    </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DateAdjust from "@/services/DateAdjust.js";
import Datepicker from 'vuejs-datepicker';
import AmountService from "../../services/amountService";
import Product from "@/services/DataStructure/Product/Product";
export default {
  name: "ProductBasedStatementComponent",
  components: { Datepicker },
  data() {
    return {
      productList: [],
      from: '',
      to: '',
      currentProduct: "",
      resultArray: [],
      stepArray:[],
      fixMode: false
    }
  },
  methods: {
    getFullDateToTimeStamp(fullDate) {
      let year = new Date(fullDate).getFullYear()
      let month = new Date(fullDate).getMonth() + 1
      if (month > 0 && month < 10) {
        month = "0" + month
      }
      let date = new Date(fullDate).getDate()
      if (date > 0 && date < 10) {
        date = "0" + date
      }
      let formattedDate = year + "-" + month + "-" + date + "T00:00:00Z"
      return new Date(formattedDate).getTime()
    },
    async getReportTraining() {
      let fromDate = this.getFullDateToTimeStamp(this.from);
      let toDate = this.getFullDateToTimeStamp(this.to);
      let transaction = await DateAdjust.printAllTrx();
      transaction.sort((a, b) => a.zz - b.zz);
      this.resultArray = transaction.filter(x => x.zz <= toDate && x.zz >= 0).filter(x => x.type === "stock").filter(x => x.info.id === this.currentProduct);
      this.stepCalculation();
      await this.accuratePurchaseRateCalculate();
      this.resultArray = this.resultArray.filter(x => x.zz <= toDate && x.zz >= fromDate)
    },
    stepCalculation() {
      // Reset the stepArray before starting calculations
      this.stepArray = [];

      // Loop through each item in resultArray
      for (let i = 0; i < this.resultArray.length; i++) {
        const current = this.resultArray[i];

        // =======================
        // Case 1: Stock is "in"
        // =======================
        if (current.status === "in") {
          // Check if an item with the same purchaseRate already exists in stepArray
          let index = this.stepArray.findIndex(x => x.purchaseRate === current.purchaseRate);

          if (index === -1) {
            // If not found, add a new entry to stepArray
            this.stepArray.push({
              quantity: current.quantity,
              purchaseRate: current.purchaseRate
            });
          } else {
            // If found, just add the quantity to the existing entry
            this.stepArray[index].quantity += current.quantity;
          }

        // =======================
        // Case 2: Stock is "out"
        // =======================
        } else if (current.status === "out") {
          // Amount of stock we want to deduct
          let saleQty = current.quantity;

          // Loop through stepArray to deduct quantities (FIFO logic)
          for (let j = 0; j < this.stepArray.length && saleQty > 0; j++) {
            const availableQty = this.stepArray[j].quantity;

            if (availableQty <= saleQty) {
              // If current quantity is less than or equal to saleQty, use it all
              saleQty -= availableQty;
              this.stepArray[j].quantity = 0;
            } else {
              // If current quantity is more than needed, deduct partial and stop
              this.stepArray[j].quantity -= saleQty;
              saleQty = 0;
            }
          }

          // After deduction, remove all items with zero quantity
          this.stepArray = this.stepArray.filter(item => item.quantity > 0);
        }

        // Save a deep copy of the current stepArray state in each result item
        // This helps in tracking how stock changed at each step
        this.resultArray[i].stockAfter = JSON.parse(JSON.stringify(this.stepArray));
        if (i < this.resultArray.length - 1) { // Ensure i+1 exists
          
          // Check if resultArray[i+1] exists, if not, initialize it
          if (!this.resultArray[i+1]) {
            this.resultArray[i+1] = {}; // Create an empty object
          }

          this.resultArray[i+1].stockBefore = this.resultArray[i].stockAfter;
        }
      }
    },
    async accuratePurchaseRateCalculate(){
      for(let i = 0; i<this.resultArray.length; i++){
        if(this.resultArray[i].status =="out"){
          console.log("out")

          let currentQty = this.resultArray[i].quantity
          let cumWeightedPrice = 0 
          for(let j = 0; j<this.resultArray[i].stockBefore.length; j++){
            if(currentQty<= this.resultArray[i].stockBefore[j].quantity){
              console.log("if")
              console.log(currentQty+"   "+this.resultArray[i].stockBefore[j].purchaseRate)

              cumWeightedPrice += currentQty*this.resultArray[i].stockBefore[j].purchaseRate
              break;
            }else{
              console.log("else")

              console.log(this.resultArray[i].stockBefore[j].quantity+"   "+this.resultArray[i].stockBefore[j].purchaseRate)


              cumWeightedPrice += this.resultArray[i].stockBefore[j].quantity*this.resultArray[i].stockBefore[j].purchaseRate
              currentQty -= this.resultArray[i].stockBefore[j].quantity
            }

          }
          this.resultArray[i].accuratePurchaseRate = parseFloat(cumWeightedPrice/this.resultArray[i].quantity).toFixed(2)
        }
      }
    },
    async fixPurchaseRate(id, accuratePurchaseRate){
      try {
            let data = {
              id: id,
              purchaseRate: accuratePurchaseRate
            }
            this.resultArray.forEach((data, index)=>{
                if(data.id==id){
                  this.resultArray[index].purchaseRate = null
                }
              })
            
            const response = await this.$http.put(`/api/trxInfo/fix`, data);
            if (response.status === 201) {
              this.$swal('Success!!!', "তথ্য সফলভাবে যোগ হয়েছে", response.data.status);
              this.resultArray.forEach((data, index)=>{
                if(data.id==id){
                  this.resultArray[index].purchaseRate = this.resultArray[index].accuratePurchaseRate
                }
              })
            } else {
              this.$swal('গোলযোগ দেখা দিয়েছে', "তথ্য যোগ করা যায়নি", response.data.status);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async loadProducts(){
      let products = await Product.getProducts()
      products.forEach((x)=>this.productList.push({value: x.id, text: x.primaryName, id: x.id}))

    }
  },
  computed: {
    AmountService() {
      return AmountService
    }

  },
  async created() {
    await this.loadProducts();
  }
}
</script>
<style scoped></style>